<template>
  <div class="icon-to-top-box">
    <img src="@/assets/images/rateTable.png" @click="onShowRateTable()" />
  </div>
</template>
      
      <script>
export default {
  props: {
    sections: {
      type: Array,
    },
    activeSection: {
      typeof: Number,
    },
  },
  data() {
    return {};
  },
  methods: {
    onShowRateTable() {
      this.$emit("onShowRateTable");
    },
  },
};
</script>
<style scoped lang="scss">
.icon-to-top-box {
  position: fixed;
  bottom: 195px;
  right: 14%;
  width: 45px;
  height: 45px;
  img {
    width: 100%;
    height: 100%;
  }
}
@media (max-width: 1441px) {
  .icon-to-top-box {
    position: fixed;
    bottom: 165px;
    right: 2%;
    width: 45px;
    height: 45px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>